import { MessageInstance } from 'antd/es/message/interface'
import { HookAPI } from 'antd/es/modal/useModal'
import { makeObservable, observable } from 'mobx'

class UiController {
  @observable message!: MessageInstance
  @observable modal!: HookAPI
  @observable test = false

  public init() {
    makeObservable(this)
  }
}

export const uiController = new UiController()
